import { useParams } from 'react-router-dom';
import * as permissionKind from '../../../../shared/permissions';
import { useGetLanguagePackQuery } from '../../../api/queries/getLanguagePack';
import LoadingElement from '../../../components/LoadingElement';
import NotFoundResult from '../../../components/results/NotFoundResult';
import hasPermissions from '../../../utilities/hasPermissions';
import LanguagePackInnerPage from './LanguagePackInnerPage';
import LanguagePackViewPage from './LanguagePackViewPage';

const LanguagePackDetailsPage = () => {
    const { languagePackId } = useParams<{ languagePackId: string }>();

    const { data, loading } = useGetLanguagePackQuery({
        variables: { id: languagePackId },
    });

    const language = data?.language;

    if (!language && loading) {
        return <LoadingElement />;
    }

    if (!language) {
        return <NotFoundResult />;
    }

    if (!hasPermissions(language.permissions, [permissionKind.updateLanguagePack])) {
        return <LanguagePackViewPage language={language} />;
    }

    return <LanguagePackInnerPage language={language} />;
};

export default LanguagePackDetailsPage;
